import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'utils/modifiedTranslation';

const DialogContentBody = ({ closeDialog, message, dialogContentButtons }) => {
  const { t } = useTranslation();
  const localStyle = {
    typography: {
      maxWidth: 360,
      margin: '0 auto 16px'
    },
    buttonGrid: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    dialogContentButtons: {
      fontWeight: 'bold'
    }
  };

  return (
    <Grid container direction="column">
      <Grid item>
        <Typography variant="subtitle1" paragraph align="center" style={localStyle.typography}>
          {t(message)}
        </Typography>
      </Grid>
      {closeDialog && (
        <Grid item style={localStyle.buttonGrid}>
          {dialogContentButtons ? (
            dialogContentButtons.map(button => (
              <Button
                key={button.key}
                color={button.color}
                size={button.size}
                variant={button.variant}
                onClick={button.onClick}
                disabled={button.disabled}
                className={button.className}
                style={{
                  ...localStyle.dialogContentButtons,
                  ...(button.style || {})
                }}
              >
                {t(button.value)}
              </Button>
            ))
          ) : (
            <Button color="primary" onClick={closeDialog} style={localStyle.dialogContentButtons}>
              {t('dialog_content_body.close')}
            </Button>
          )}
        </Grid>
      )}
    </Grid>
  );
};

DialogContentBody.propTypes = {
  closeDialog: PropTypes.func,
  message: PropTypes.string,
  dialogContentButtons: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number,
      color: PropTypes.string,
      value: PropTypes.string,
      size: PropTypes.string,
      variant: PropTypes.string,
      onClick: PropTypes.func,
      style: PropTypes.object
    })
  )
};

DialogContentBody.defaultProps = {
  closeDialog: null,
  dialogContentButtons: null,
  message: null
};

export default DialogContentBody;
